import {
  Table,
  Input,
  Modal,
  Button,
  success,
  LinkBtn,
  EyeIcon,
  useState,
  useDelete,
  updateList,
  ErrorAlert,
  Breadcrumb,
  EyeSlashIcon,
  modalHandler,
  useFetchData,
  ModalOpenBtn,
  PageHero,
  DownloadExcel,
  useCustomForm,
  UserGroupIcon,
  useTableColumns,
  useDebouncedSearch,
  TableRowsPerPage,
} from "@";
import { getUsers, saveUser } from "./utils/api";
import { excelHeaderCellsName } from "./utils/options";
import { editDefaultValues, editSchema } from "./utils/validation";
import { TableActions, tableColumns } from "./components/TableOptions";

const Index = () => {
  const [search, setSearch] = useState(""); // search query
  const [showPassword, setShowPassword] = useState(false);

  // Breadcrumb links
  const links = [
    { name: "الاعدادات", link: "/all-settings" },
    { name: "موظفي المتجر", link: "" },
  ];

  // Form setup
  const { reset, errors, register, handleSubmit, isSubmitting } = useCustomForm(
    editDefaultValues,
    editSchema,
  );

  // Fetch data
  const { data, isLoading, setData, error, pg, fetchData, updatePg } =
    useFetchData({
      fun: getUsers,
      params: [search],
    });

  useDebouncedSearch(fetchData, search);

  // Delete handler
  const { deleteHandler } = useDelete(data, setData, "users");

  // Table columns setup
  const columns = useTableColumns(
    tableColumns,
    (row) => (
      <TableActions
        row={row}
        handlerEdit={(item) => {
          reset(item);
          modalHandler();
        }}
        deleteHandler={deleteHandler}
      />
    ),
    1,
  );

  // Form submit handler
  const submit = async (form) => {
    try {
      await saveUser(form);
      setData(updateList(data, form));
      success("تم الحفظ بنجاح");
      modalHandler();
      reset();
    } catch (error) {}
  };

  return (
    <>
      {/* Error alert */}
      <ErrorAlert reload={fetchData} show={error} />
      <Breadcrumb links={links} />

      {/* Modal for editing user */}
      <ModalOpenBtn hidden />
      <Modal close={reset} title="تعديل">
        <form onSubmit={handleSubmit(submit)} className="p-4">
          <Input
            style="mb-5"
            label="الاسم"
            error={errors.displayName}
            input={register("displayName")}
          />
          <Input
            style="mb-5"
            label="البريد الالكتروني"
            error={errors.email}
            input={register("email")}
          />
          {/* Password field with toggle visibility */}
          <div className="relative mb-5">
            <Input
              star
              label="كلمة المرور"
              error={errors.password}
              autocomplete="new-password"
              input={register("password")}
              type={showPassword ? "text" : "password"}
              placeholder="اترك الحقل فارغاً في حالة عدم تغيير كلمة المرور"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="icon-style absolute end-0 top-[31px] rounded-2xl rounded-s-none"
            >
              {showPassword ? (
                <EyeSlashIcon className="h-6 w-6" />
              ) : (
                <EyeIcon className="h-6 w-6" />
              )}
            </button>
          </div>
          <Button isLoading={isSubmitting} type="submit" title="حفظ البيانات" />
        </form>
      </Modal>

      <main className="table-card relative">
        <PageHero
          eyebrow="الإعدادات / المستخدمين"
          title="موظفي المتجر"
          count={pg.rows}
          icon={UserGroupIcon}
          hideCount={isLoading}
        >
          <input
            className="single-search-input"
            onChange={(e) => setSearch(e.target.value)}
            placeholder="بحث"
            value={search}
            type="search"
          />

          <TableRowsPerPage
            pagination={pg}
            onRowsPerPageChange={(size) => updatePg({ size: size })}
          />

          <DownloadExcel
            fetch={getUsers}
            search={search}
            length={data?.length}
            headerCellsName={excelHeaderCellsName}
            logExport={{ action: 3, description: "تصدير موظفي المتجر" }}
          />
          <LinkBtn to="/settings-users/create" create />
        </PageHero>

        {/* Table */}
        <Table
          data={data}
          pagination={pg}
          columns={columns}
          isLoading={isLoading}
          pageChange={(page) => updatePg({ page: page })}
          perRowsChange={(size) => updatePg({ size: size })}
        />
      </main>
    </>
  );
};

export default Index;
